import React from 'react';
import { Text } from '@wix/design-system';
import s from './Content.scss';
import { Trans, useTranslation } from 'react-i18next';
import { PremiumCurrencyFormatter } from '@wix/premium-react-text';
import { RootStore, withInjectedRootStore } from '../../../../providers';
import classNames from 'classnames';

interface CreditProps {
  rootStore: RootStore;
}

export const CreditComp: React.FC<CreditProps> = ({ rootStore }) => {
  const { t } = useTranslation();
  if (rootStore.appStore.appContext.availableCredit < 10) {
    return (
      <Text className={s.withDash} light>
        {t('app.second_upgrade_text')}
      </Text>
    );
  }

  return (
    <Text className={classNames(s.withDash, s.contentWrapper)} light>
      <PremiumCurrencyFormatter
        render={(formatCurrency) => {
          const { currentPlanDetails, availableCredit } =
            rootStore.appStore.appContext;
          const currentPlan = currentPlanDetails?.planName;
          const credit = formatCurrency(Math.floor(availableCredit), {
            hideZeroDecimals: true,
          });
          return (
            <Trans
              i18nKey='app.second_upgrade_optimization.subtitle'
              values={{ credit, currentPlan }}
              components={{
                creditPart: <b />,
              }}
            ></Trans>
          );
        }}
      />
    </Text>
  );
};

export const Credit = withInjectedRootStore(CreditComp);
